/**
 * Logo component - the canonical Orthodox-Way symbol.
 * Uses CSS `currentColor` so the wrapping element's text colour drives the fill.
 */

type Props = {
  size?: number;
  className?: string;
  ariaLabel?: string;
};

export function Logo({ size = 28, className, ariaLabel = 'Orthodox Way' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="currentColor">
        <path
          d="M 123.22 193.15 A 96 96 0 1 0 76.78 193.15"
          fill="none"
          stroke="currentColor"
          strokeWidth="6"
        />
        <rect x="93" y="33" width="14" height="166" />
        <rect x="75" y="51" width="50" height="13" />
        <rect x="45" y="82" width="110" height="13" />
        <path d="M 78 132 L 122 157 L 122 170 L 78 145 Z" />
      </g>
    </svg>
  );
}
